export const enecoNavlinkOncolorColors = {
  navLinkSecondaryOnColorDefault: '{{ linkColors.linkPrimary }}',
  navLinkSecondaryOnColorHover: '{{ linkColors.linkPrimary }}',
  navLinkSecondaryOnColorFocusOutline: '{{ borderColors.borderFocus }}',
  navLinkTertiaryOnColorDefault: '{{ linkColors.linkSecondary }}',
  navLinkTertiaryOnColorHover: '{{ linkColors.linkPrimary }}',
  navLinkTertiaryOnColorFocusOutline: '{{ borderColors.borderFocus }}',
};
